<!-- Department header -->
<app-dept-header *ngIf="showDeptMenu"></app-dept-header>

<!-- Event Slider -->
<section id="homepage-slider">
  <ngb-carousel>
    <ng-template ngbSlide *ngFor="let slide of slidesData">
      <div class="picsum-img-wrapper slider-image">
        <img src="{{slide.image}}" alt="Random first slide">
      </div>
      <div class="carousel-caption">
        <h3>{{slide.title}}</h3>
        <p>{{slide.sub_title}}</p>
      </div>
    </ng-template>
  </ngb-carousel>
</section>
<!-- end Event Slider -->

<!-- Page Content -->
<div id="page-content">
  <div class="container">
    <div class="row block">
      <!--MAIN Content-->
      <div class="col-md-8">
        <div id="page-main">
          <section class="events images" id="events">
            <header><h2>All Events</h2></header>
            <div *ngIf="allEventsData.length == 0">
              <h3>No Events...</h3>
            </div>
            <div *ngIf="allEventsData.length != 0">
              <div class="section-content" >
                <article class="event" *ngFor="let event of allEventsData let i=index">
                  <div class="event-thumbnail">
                    <figure class="event-image">
                      <div class="image-wrapper">
                        <a routerLink="/info/{{event.id}}">
                          <img src="{{event.images}}">
                        </a>
                      </div>
                    </figure>
                    <figure class="date {{eventColor+(i+1)}}">
                      <div class="month">{{ event.commence_date | date:'MMMM' }}</div>
                      <div class="day">{{ event.commence_date | date:'d' }}</div>
                    </figure>
                  </div>
                  <aside>
                    <header>
                      <a routerLink="/info/{{event.id}}">{{event.title}}</a>
                    </header>

                    <div class="additional-info"><span class="fa fa-calendar"></span>
                      <span> {{ event.commence_date | date:'MMMM d, y' }}</span>
                      <span *ngIf="event.complete_date != event.commence_date">
                        to {{ event.complete_date | date:'MMMM d, y' }}
                      </span>
                    </div>

                    <div class="description">
                      <p>{{event.short_desc}}</p>
                    </div>
                  </aside>
                </article><!-- /.info -->
              </div>
            </div><!-- /.section-content -->
          </section><!-- /.information-images -->
          <hr>

        </div><!-- /#page-main -->
      </div><!-- /.col-md-8 -->
      <!--SIDEBAR Content-->
      <div class="col-md-4">
        <div id="page-sidebar" class="sidebar">
          <aside class="news-small" id="news-small">
            <header>
              <h2>Events this year</h2>
            </header>
            <div class="section-content">
              <article *ngFor="let event of allEventsData">
                <figure class="date"><i class="fa fa-calendar"></i>{{ event.commence_date | date:'MMMM d, y' }}</figure>
                <header><a routerLink="/info/{{event.id}}">{{event.title.slice(0,50)}}...</a></header>
              </article><!-- /article -->
            </div><!-- /.section-content -->
          </aside><!-- /.news-small -->

        </div><!-- /#sidebar -->
      </div><!-- /.col-md-4 -->
    </div>
  </div>


</div>
<!-- end Page Content -->
